(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["echo-featured-products"] && !Shopify.designMode) return;
  try {
    
window.addEventListener("load", function () {
  const sliderEl = document.querySelector(".js-slick-slider");
  const prevArrow = document.querySelector(".product-tab-prev");
  const nextArrow = document.querySelector(".product-tab-next");

  if (!sliderEl) return;

  const slidesDesktop = parseInt("{{ section.settings.slidesperview }}", 10) || 4;
  const slidesMobile = parseInt("{{ section.settings.slidesperviewmb }}", 10) || 1;

  function initSlick() {
    const slidesToShow = window.innerWidth < 768 ? slidesMobile : slidesDesktop;

    if (!jQuery(sliderEl).hasClass("slick-initialized")) {
      jQuery(sliderEl).slick({
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        responsive: [
          {
            breakpoint: 768,
            settings: { slidesToShow: slidesMobile }
          }
        ]
      });
    }

    jQuery(sliderEl).slick("setPosition");
  }

  initSlick();

  window.addEventListener("resize", function () {
    if (jQuery(sliderEl).hasClass("slick-initialized")) {
      setTimeout(() => jQuery(sliderEl).slick("setPosition"), 100);
    }
  });
});

// Shopify editor reload support
document.addEventListener("shopify:section:load", function () {
  if (window.location && document.querySelector(".js-slick-slider")) {
    // Re-run initialization after Shopify editor reloads section
    window.dispatchEvent(new Event('load'));
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tab-button");
  const contents = document.querySelectorAll(".tab-content");

  function initSlider($slider, $prevArrow, $nextArrow) {
    $slider.not('.slick-initialized').slick({
      slidesToShow: window.innerWidth < 768 ? 1 : 4, // Responsive manually
      arrows: true,
      infinite: true,
      prevArrow: $prevArrow,
      nextArrow: $nextArrow,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", function () {
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      this.classList.add("active");
      contents[index].classList.add("active");

      const tabContent = contents[index];
      const $slider = jQuery(tabContent).find('.product-slider');
      const $prevArrow = jQuery(tabContent).find('.product-tab-prev');
      const $nextArrow = jQuery(tabContent).find('.product-tab-next');

      // Delay to ensure layout is visible
      setTimeout(() => {
        initSlider($slider, $prevArrow, $nextArrow);
        $slider.slick('setPosition');
      }, 100);
    });
  });

  // Manually trigger click on the first tab
  if (tabs.length > 0) {
    tabs[0].click();
  }
});


  } catch(e) { console.error(e); }
})();
})();
